import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from 'locales/en/translation.json';
import translationKO from 'locales/ko/translation.json';
import translationJP from 'locales/jp/translation.json';
import useGetLocalStorageLanguage from '../hooks/useGetLocalStorageLanguage';

let selectedLanguage = useGetLocalStorageLanguage();

const resources = {
  en: {
    translation: translationEN,
  },
  ko: {
    translation: translationKO,
  },
  jp: {
    translation: translationJP,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: selectedLanguage, // 기본 설정 언어
  fallbackLng: 'en', // 번역 파일에서 찾을 수 없는 경우 대체 언어
  interpolation: {
    // 보간법(동적 바인딩 가능)
    escapeValue: false, // xss 공격을 안화하기 위한 이스케이프 처리
  },
});

export default i18n;
